<div class="filter-bar">
  <input class="filter-input" [ngModel]="invSearch" (ngModelChange)="setInvSearch($event)" placeholder="Search items…" autocomplete="off">
  <select class="filter-select" [ngModel]="invSubtypeFilter" (ngModelChange)="setInvSubtypeFilter($event)">
    <option *ngFor="let opt of invFilterOptions" [value]="opt.value">{{ opt.label }}</option>
  </select>
  <select class="filter-select rarity-select" [ngClass]="invRarityFilter !== 'all' ? 'rarity-' + invRarityFilter : ''" [ngModel]="invRarityFilter" (ngModelChange)="setInvRarityFilter($event)">
    <option *ngFor="let opt of invRarityOptions" [value]="opt.value" [style.color]="rarityColor(opt.value)">{{ opt.label }}</option>
  </select>
  <label class="inv-new-filter" *ngIf="invNewItems.size > 0">
    <input type="checkbox" [ngModel]="invShowNewOnly" (ngModelChange)="setInvNewOnly($event)">
    <span class="inv-new-label">New ({{ invNewItems.size }})</span>
  </label>
  <button type="button" class="filter-clear-btn" (click)="clearFilters()" [disabled]="!hasActiveFilters" title="Clear all filters">Clear</button>
</div>

<div class="inv-sort-bar">
  <span class="sort-col" (click)="setInvSort('name')">Name<span class="sort-ind">{{ invSortBy === 'name' ? (invSortAsc ? ' ↑' : ' ↓') : '' }}</span></span>
  <span class="sort-col" (click)="setInvSort('qty')">Qty<span class="sort-ind">{{ invSortBy === 'qty' ? (invSortAsc ? ' ↑' : ' ↓') : '' }}</span></span>
</div>

<div *ngIf="groupedInventory.length === 0" class="inv-empty">No items found.</div>

<ng-container *ngFor="let group of groupedInventory; trackBy: trackGroup">
  <div class="inv-group-header">
    {{ group.label }}
    <span class="inv-group-count">{{ group.items.length }}</span>
  </div>
  <div class="inv-list">
    <div class="inv-item-block" *ngFor="let item of group.items; trackBy: trackItem">
      <div class="inv-item"
           [class.inv-item-on-ship]="invIsOnShip(item)"
           [class.inv-item-expanded]="isExpanded(item)"
           (click)="toggleExpanded(item)">
        <div class="inv-item-main">
          <div class="inv-sprite-wrap">
            <pss-sprite *ngIf="showSprites && itemSpriteId(item.designId)" class="inv-sprite" [spriteId]="itemSpriteId(item.designId)"></pss-sprite>
            <span *ngIf="!showSprites || !itemSpriteId(item.designId)" class="inv-sprite-placeholder">?</span>
          </div>
          <div class="inv-item-info">
            <div class="inv-item-name-wrap">
              <span class="inv-item-name" [class]="'rarity-' + (itemRarity(item.designId) | lowercase)">{{ itemName(item.designId) }}</span>
              <span class="inv-item-main-stat" *ngIf="showStats && itemMainBonusText(item) as main">{{ main }}</span>
            </div>
            <ng-container *ngIf="showStats && itemAdditionalBonusText(item) as extras">
              <span class="inv-item-additional-stat">{{ extras }}</span>
            </ng-container>
          </div>
          <div class="inv-item-right">
            <span class="inv-item-on-ship-badge" *ngIf="invIsOnShip(item)" title="Equipped on active crew">●</span>
            <span class="inv-qty-detail" *ngIf="item.quantity > 1">
              <span class="inv-qty-free">{{ invFreeCount(item) }}</span><span class="inv-qty-sep">(</span><span class="inv-qty-used">{{ item.quantity }}</span><span class="inv-qty-sep">)</span>
            </span>
          </div>
        </div>

        <div class="inv-flyout" *ngIf="showStats && isExpanded(item)">
          <div class="inv-flyout-row">
            <span class="inv-flyout-label">Type</span>
            <span class="inv-flyout-val">{{ itemTypeLabel(item.designId) }}</span>
          </div>
          <div class="inv-flyout-row" *ngIf="itemDescription(item.designId)">
            <span class="inv-flyout-label">Description</span>
            <span class="inv-flyout-val inv-flyout-desc">{{ itemDescription(item.designId) }}</span>
          </div>
          <div class="inv-flyout-row" *ngIf="itemMainStatText(item) as main">
            <span class="inv-flyout-label">Stat</span>
            <span class="inv-flyout-val">{{ main }}</span>
          </div>
          <ng-container *ngFor="let group of itemBonusGroups(item); let first = first">
            <div class="inv-flyout-section-title inv-stats-title" *ngIf="first">Secondary Stats</div>
            <div class="inv-flyout-row">
              <span class="inv-flyout-label">{{ group.stat }}</span>
              <div class="inv-stat-chips">
                <span class="inv-stat-chip" *ngFor="let chip of group.chips">{{ chip }}</span>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="item.equippedBy.length > 0">
            <div class="inv-flyout-section-title">Worn By</div>
            <div class="inv-wornby-list">
              <div class="inv-wornby-row" *ngFor="let c of item.equippedBy">
                <pss-sprite *ngIf="crewSpriteId(c.designId)" class="inv-wornby-sprite" [spriteId]="crewSpriteId(c.designId)"></pss-sprite>
                <span class="inv-wornby-status" [class.inv-wornby-deployed]="c.deployed && !c.donated" [class.inv-wornby-donated]="c.donated">
                  {{ c.deployed && !c.donated ? '▲' : (c.donated ? '⇒' : '▽') }}
                </span>
                <div class="inv-wornby-info">
                  <span class="inv-wornby-name">{{ crewName(c) }}</span>
                  <span class="inv-wornby-stat" *ngIf="itemCrewStat(item, c)" [class.inv-wornby-stat-shimmer]="itemCrewStatMatch(item, c)"> {{ itemCrewStat(item, c) }}</span>
                  <span class="inv-wornby-room">{{ crewRoomName(c) }}</span>
                </div>
                <span class="inv-wornby-level">Lv {{ c.level }}</span>
              </div>
            </div>
          </ng-container>

          <div class="inv-flyout-actions" *ngIf="isConsumable(item) && basicPlus">
            <button class="btn btn-warning btn-sm" (click)="requestUseItem(item, $event)">
              Use Item{{ invFreeCount(item) > 1 ? 's' : '' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
